var render = function render(){var _vm=this,_c=_vm._self._c;return _c('menu-layout',{attrs:{"loading":_vm.loading}},[_c('row',[_c('col2',[_c('page-menu',{attrs:{"name":_vm.$t('auto_t.name'),"title":_vm.$t('auto_t.title'),"items":[
                    {'name': _vm.$t('auto_t.clean_duplicates'), 'route': '/auto'},
                    {'name': _vm.$t('auto_t.suggestions'), 'route': '/auto/suggestions'}
                ]}})],1),_c('col10',{staticStyle:{"max-width":"1500px"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }